<template>
  <div class="residential-account-properties">
    <div
      class="residential-account-properties__property"
      v-for="(property, index) in properties"
      :key="property.key + index"
    >
      <div class="residential-account-properties__property-label">{{ property.label || $tc(property.key) }}</div>
      <div class="residential-account-properties__property-value">{{ property.formatted }}</div>
    </div>
    <SlotComponent placement="residentialAccount:properties" :query="{ residentialAccount: $route.params.id }" />
  </div>
</template>

<script>
import SlotComponent from '@/components/Slot'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    properties() {
      return (this.$path('properties', this.value) || []).filter(p => p.formatted)
    },
  },
  components: {
    SlotComponent,
  },
}
</script>

<style lang="scss">
.residential-account-properties {
  margin-top: 3rem;
  overflow-x: auto;
  color: $dark;
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;

  &__title {
    font-size: 1.5em;
    opacity: 0.8;
  }
  &__property {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    &-label {
      text-transform: uppercase;
      opacity: 0.7;
      font-size: 0.6em;
    }

    &-value {
      font-weight: bold;
      font-size: 1em;
    }
  }

  .slot {
    width: 100%;

    & > * {
      display: flex;
      justify-content: start;
      flex-wrap: wrap;
    }
  }
}
</style>
